
import {defineComponent} from 'vue';
import Icon from '@ohrm/oxd/core/components/Icon/Icon.vue';
import {pageableMixin} from '../../../mixins/pageable';

export default defineComponent({
  name: 'oxd-pagination-page-item',

  components: {
    'oxd-icon': Icon,
  },

  mixins: [pageableMixin],

  props: {
    previous: {
      type: Boolean,
    },
    next: {
      type: Boolean,
    },
    selected: {
      type: Boolean,
    },
  },

  computed: {
    classes(): object {
      return {
        'oxd-pagination-page-item': true,
        'oxd-pagination-page-item--page': !(this.previous || this.next),
        'oxd-pagination-page-item--page-selected': this.selected,
        'oxd-pagination-page-item--previous-next': this.previous || this.next,
      };
    },
  },
});
